<template>
    <div class="flex flex-col w-full h-full bg-white rounded-lg text-black text-center">
        <div class="relative h-32 rounded-t-lg">
            <svg class="rounded-t-lg" style="box-sizing: border-box; position:absolute; right: 0; left: 0; top: 0; bottom: 0; opacity: 0.6; height: 100%; width: 100%;" preserveAspectRatio="none" role="img" viewBox="0 0 42 23" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                <filter color-interpolation-filters="sRGB" id="blurMe">
                    <feGaussianBlur edgeMode="duplicate" tableValues="1 1" stdDeviation="1.2" />
                    <feComponentTransfer>
                        <feFuncA tableValues="1 1" type="discrete"></feFuncA>
                    </feComponentTransfer>
                </filter>
                <image filter="url(#blurMe)" height="23" width="42" x="0" xlink:href="https://media-preview.livestormsvideo.com/thumbnails/2018/10/11/5f327b58477a8b6a61684a0973a1c148-00001.png" y="0"></image>
            </svg>
        </div>
        <div class="z-50 p-4 -mt-20">
            <div class="py-2">
                <gravatar :hash="chaser.gravatar_hash" class="h-20 w-20 lg:h-24 lg:w-24 rounded-full mx-auto"></gravatar>
            </div>
            <h1 class="text-xl py-4">{{ chaser.name }}</h1>
            <!-- <div class="py-2">
                twitter fb
            </div> -->
        </div>
    </div>
</template>

<script>
    import Gravatar from 'vue-gravatar';

    export default {
        name: 'ChaserCard',
        components: {
            Gravatar
        },
        props: [
            'chaser'
        ],
    }
</script>

<style scoped>
    .h-40 {
        height: 10rem;
    }
</style>